var _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJosn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.179,
    height: 38.814,
    viewBox: "0 0 30.179 38.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "josn",
    transform: "translate(-456.909 329.733)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M261.012,1253.267l9.2,9.068h-9.2Z",
    transform: "translate(216.875 -1583)",
    fill: "#5d5d5d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_6",
    "data-name": "XMLID 86 6",
    transform: "translate(216.875 -1583)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M261.012,1253.267h-18.85v38.814h28.051v-29.757Z",
    fill: "#5d5d5d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2042",
    "data-name": "Group 2042",
    transform: "translate(216.875 -1583)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_84_6",
    "data-name": "XMLID 84 6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1467",
    "data-name": "Rectangle 1467",
    width: 28,
    height: 13.286,
    transform: "translate(240.034 1271.46)",
    fill: "#4a519e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_83_6",
    "data-name": "XMLID 83 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M240.034,1284.743l2.128,1.8v-1.8Z",
    fill: "#4a519e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_.josn",
    "data-name": " .josn",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2041",
    "data-name": "Group 2041",
    style: {
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M242.768,1281.869a.66.66,0,0,1,.468-1.128.607.607,0,0,1,.452.192.682.682,0,0,1,0,.936.607.607,0,0,1-.452.192A.635.635,0,0,1,242.768,1281.869Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M246.2,1283.262a1.481,1.481,0,0,1-.394,1.139,1.641,1.641,0,0,1-1.149.361H244.1v-.818h.4a.811.811,0,0,0,.569-.16.735.735,0,0,0,.165-.543v-7.073h.968Zm-.942-8.232a.682.682,0,0,1,0-.936.654.654,0,0,1,.926,0,.682.682,0,0,1,0,.936.657.657,0,0,1-.926,0Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M248.942,1281.72a2.646,2.646,0,0,1-1.042-1.058,3.242,3.242,0,0,1-.377-1.59,3.149,3.149,0,0,1,.388-1.58,2.673,2.673,0,0,1,1.058-1.053,3.249,3.249,0,0,1,3,0,2.685,2.685,0,0,1,1.058,1.048,3.142,3.142,0,0,1,.388,1.585,3.106,3.106,0,0,1-.4,1.59,2.762,2.762,0,0,1-1.079,1.058,3.087,3.087,0,0,1-1.511.373A2.976,2.976,0,0,1,248.942,1281.72ZM251.4,1281a1.861,1.861,0,0,0,.739-.734,2.348,2.348,0,0,0,.282-1.191,2.386,2.386,0,0,0-.277-1.192,1.8,1.8,0,0,0-.723-.728,2.082,2.082,0,0,0-1.941,0,1.753,1.753,0,0,0-.708.728,2.473,2.473,0,0,0-.265,1.192,2.529,2.529,0,0,0,.26,1.2,1.729,1.729,0,0,0,.7.728,1.952,1.952,0,0,0,.957.239A2.047,2.047,0,0,0,251.4,1281Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M255.6,1281.864a2.024,2.024,0,0,1-.841-.638,1.7,1.7,0,0,1-.34-.942h1a.981.981,0,0,0,.409.713,1.563,1.563,0,0,0,.963.277,1.4,1.4,0,0,0,.872-.245.748.748,0,0,0,.32-.617.609.609,0,0,0-.341-.569,4.749,4.749,0,0,0-1.053-.367,7.662,7.662,0,0,1-1.059-.346,1.869,1.869,0,0,1-.7-.521,1.356,1.356,0,0,1-.293-.91,1.379,1.379,0,0,1,.266-.818,1.8,1.8,0,0,1,.755-.591,2.725,2.725,0,0,1,1.117-.218,2.384,2.384,0,0,1,1.563.489,1.763,1.763,0,0,1,.639,1.341H257.9a1,1,0,0,0-.367-.734,1.365,1.365,0,0,0-.9-.277,1.383,1.383,0,0,0-.829.224.688.688,0,0,0-.309.584.642.642,0,0,0,.186.474,1.35,1.35,0,0,0,.468.3,7.612,7.612,0,0,0,.782.25,8.423,8.423,0,0,1,1.021.336,1.788,1.788,0,0,1,.675.495,1.317,1.317,0,0,1,.293.861,1.481,1.481,0,0,1-.266.862,1.767,1.767,0,0,1-.75.6,2.67,2.67,0,0,1-1.111.219A3.021,3.021,0,0,1,255.6,1281.864Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M264.892,1276.7a2.476,2.476,0,0,1,.66,1.856V1282h-.958v-3.3a1.871,1.871,0,0,0-.436-1.334,1.557,1.557,0,0,0-1.191-.463,1.592,1.592,0,0,0-1.218.479,1.949,1.949,0,0,0-.452,1.393V1282h-.968v-5.829h.968V1277a1.915,1.915,0,0,1,.782-.691,2.422,2.422,0,0,1,1.09-.245A2.363,2.363,0,0,1,264.892,1276.7Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJosn);
export default __webpack_public_path__ + "static/media/josn.40ab35e8527fdeb85e36eba117c36e2f.svg";
export { ForwardRef as ReactComponent };